(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rdwf-social-proof')) {
    customElements.define('rdwf-social-proof', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.dataset.ready = 'true';
        this.button = this.querySelector('.rdwf-proof__motion-button');

        if (this.button) {
          this.handleToggle = () => {
            const isPaused = !this.classList.contains('is-paused');
            const update = () => this.setMotionState(isPaused);
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            if (!reduceMotion && document.startViewTransition) {
              document.startViewTransition(update);
            } else {
              update();
            }
          };

          this.button.addEventListener('click', this.handleToggle);
        }

        this.startAutoRefresh();
      }

      disconnectedCallback() {
        if (this.button && this.handleToggle) {
          this.button.removeEventListener('click', this.handleToggle);
        }

        if (this.refreshTimer) {
          window.clearInterval(this.refreshTimer);
        }

        delete this.dataset.ready;
      }

      startAutoRefresh() {
        if (this.dataset.autoRefresh !== 'true') return;
        if (window.Shopify && window.Shopify.designMode) return;

        const minutes = Number.parseInt(this.dataset.refreshMinutes, 10);
        if (!Number.isFinite(minutes) || minutes < 1) return;

        this.refreshTimer = window.setInterval(() => {
          this.refreshProducts();
        }, minutes * 60 * 1000);
      }

      async refreshProducts() {
        if (document.hidden || this.dataset.refreshing === 'true') return;

        this.dataset.refreshing = 'true';

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('_rdwf_refresh', Date.now().toString());

          const response = await fetch(url.toString(), {
            headers: { Accept: 'text/html' }
          });

          if (!response.ok) return;

          const markup = await response.text();
          const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
          const refreshedSection = documentFragment.querySelector('rdwf-social-proof');

          if (refreshedSection) {
            this.replaceWith(refreshedSection);
          }
        } catch {
          return;
        } finally {
          delete this.dataset.refreshing;
        }
      }

      setMotionState(isPaused) {
        const label = isPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
        const icon = this.button.querySelector('.rdwf-proof__motion-icon');
        const text = this.button.querySelector('.rdwf-proof__motion-label');

        this.classList.toggle('is-paused', isPaused);
        this.button.setAttribute('aria-pressed', String(isPaused));
        this.button.setAttribute('aria-label', label);

        if (icon) icon.textContent = isPaused ? '▶' : 'Ⅱ';
        if (text) text.textContent = label;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
